import { useEffect, useState } from 'react';
import {
  commonExchangeRateQuery,
  ExchangeRateDto,
  outsourceCommonExchangeRateQuery,
} from '#services/api';
import { $sType } from '#utils';

// 全局单例缓存与并发控制
let cachedChangeRateList: ExchangeRateDto[] | undefined;
let fetchingPromise: Promise<ExchangeRateDto[]> | null = null;

export const useChangeRate = () => {
  const [changeRateList, setChangeRateList] = useState<ExchangeRateDto[]>(
    cachedChangeRateList !== undefined ? cachedChangeRateList : []
  );

  useEffect(() => {
    // 已有缓存则直接返回
    if (cachedChangeRateList !== undefined) return;
    // 防止并发重复请求
    if (!fetchingPromise) {
      fetchingPromise = new Promise((resolve, reject) => {
        const query =
          $sType === 'outer'
            ? outsourceCommonExchangeRateQuery
            : commonExchangeRateQuery;
        query({})
          .then((res: any) => {
            const value = res?.data || [];
            cachedChangeRateList = value;
            resolve(value)
          })
          .finally(() => {
            fetchingPromise = null;
          });
      });
    }

    let mounted = true;
    fetchingPromise.then((value) => {
      if (!mounted) return;
      setChangeRateList(value);
    });

    return () => {
      mounted = false;
    };
  }, []);

  return {
    changeRateList,
  };
};
